import * as React from 'react';
import { SVGProps } from 'react';

const IconDataNullSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.566 2a1 1 0 0 0-.857.486L.143 6.761A1 1 0 0 0 0 7.277V13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7.277a1 1 0 0 0-.143-.515l-2.566-4.276A1 1 0 0 0 12.434 2H3.566ZM13.5 7 12 4H4L2.5 7H4a1 1 0 0 1 1 1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 1 1-1h1.5Z"
    />
  </svg>
);
export default IconDataNullSizeS;
